<template>
  <div class="home">
    <!-- 下载按钮 -->
    <div class="download-container">
      <button class="download-btn" @click="handleDownload">
        <img
          src="~@/assets/download.png"
          alt=""
          style="width: 24px; height: 24px; margin-right: 10px"
        />
        点击下载 APP
      </button>
      <img
        src="~@/assets/dj.gif"
        alt=""
        style="
          width: 92px;
          height: 80px;
          position: absolute;
          bottom: -25%;
          right: -10%;
          transform: translate(-50%, -50%);
        "
      />
    </div>

    <!-- 微信引导蒙层 -->
    <div v-if="showWechatGuide" class="wechat-guide" @click="hideWechatGuide">
      <div class="guide-content">
        <div class="guide-text">
          <p>1.点击右上角...</p>
          <p>2.选择在默认浏览器中打开</p>
        </div>
        <div class="guide-image">
          <img src="~@/assets/right.png" alt="提示图片" class="hint-image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      showWechatGuide: false,
      downloadUrl: "https://m.malink.cn/s/ZfmMNz", // 替换为实际的下载链接
    };
  },
  methods: {
    // 检测是否在微信浏览器中
    isWechatBrowser() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf("micromessenger") !== -1;
    },

    // 检测是否为iOS设备
    isIOS() {
      const ua = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(ua);
    },

    // 检测是否为Android设备
    isAndroid() {
      const ua = window.navigator.userAgent.toLowerCase();
      return /android/.test(ua) && !/windows phone/.test(ua);
    },

    // 处理下载按钮点击
    handleDownload() {
      if (this.isWechatBrowser()) {
        // 在微信中，显示引导蒙层
        this.showWechatGuide = true;
      } else {
        // 不在微信中，根据设备类型选择不同的下载链接
        let downloadUrl;
        if (this.isIOS()) {
          downloadUrl =
            "https://apps.apple.com/cn/app/%E4%B9%90%E9%BE%84/id6753137834";
        } else if (this.isAndroid()) {
          downloadUrl = "https://m.malink.cn/s/ZfmMNz";
        } else {
          // 默认使用安卓链接
          downloadUrl = "https://m.malink.cn/s/ZfmMNz";
        }
        window.location.href = downloadUrl;
      }
    },

    // 隐藏微信引导蒙层
    hideWechatGuide() {
      this.showWechatGuide = false;
    },
  },
};
</script>

<style scoped>
body {
  background-color: #fc4631;
}
.home {
  width: 100%;
  min-height: 100vh;
  background-image: url("~@/assets/bg-ll.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top center;
  background-color: #fc4631;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.download-container {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
}

.download-btn {
  width: 100%;
  padding: 26px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(252, 70, 49);
  background-color: #ffffff;
  border: none;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(25, 137, 250, 0.3);
  transition: all 0.3s ease;
  margin-top: 650px;
}

.download-btn:hover {
  background-color: #ffffff;
  /* box-shadow: 0 6px 16px rgba(#); */
}

.download-btn:active {
  transform: scale(0.98);
}

/* 微信引导蒙层样式 */
.wechat-guide {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 60px;
  z-index: 1000;
  cursor: pointer;
}

.guide-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  max-width: 800px;
  position: relative;
}

.guide-text {
  color: white;
  font-size: 22px;
  line-height: 1.6;
  flex: 1;
  margin-right: 30px;
  padding-top: 15px;
  text-align: left;
  /* width: 50%; */
}

.guide-text p {
  margin: 15px 0;
  width: 65%;
}

.guide-text p:first-child {
  /* font-size: 18px; */
  font-weight: bold;
}

.guide-text p:last-child {
  /* font-size: 18px; */
  color: #ffffff;
  font-weight: bold;
}

.guide-image {
  position: absolute;
  top: -20%;
  right: -1%;
  /* transform: translate(-50%, -50%); */
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hint-image {
  width: 200px;
  height: auto;
  max-height: 200px;
  object-fit: contain;
}
</style>
